// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1uo_k","savePackageButton":"ClientWallet_savePackageButton__3dP5Z"};